import React from 'react'
import closeLogo from '../../../assets/images/Close Window.png';
import { useState } from 'react';
import { setToastMessage } from '../../../reducers/common.reducer';
import { useDispatch } from 'react-redux';

const AddEquation = (props) => {

    const { currentGameType, gameTypeEquation, setGameTypeEquation} = props;

    const [equation , setEquation]=useState("");
    const [exchangeUnit, setExchangeUnit]=useState(0);
    const [positive, setPositive]=useState(false);
   
    let dispatch = useDispatch();
   
    const checkRegex=(value)=>{
        return /^\d+(\.\d+)?$/.test(value);
    }
     
    const handelAddEquation=()=>{
       
        if(gameTypeEquation.find(item => item.gameType === currentGameType?.gameType)) {
           
            dispatch(
                setToastMessage({
                message: "Game Type Already Added",
                type: "error",
                })
            );
            return
        }
        
        if(!currentGameType) {
            dispatch(
                setToastMessage({
                message: "Please Select GameType",
                type: "error",
                })
            );
            return
        }
        if (!exchangeUnit){
            dispatch(
                setToastMessage({
                message: "Exchange Unit is required!",
                type: "error",
                })
            );
            return
        }
        if(!checkRegex(exchangeUnit)) {
            dispatch(
                setToastMessage({
                message: "Exchange Unit must be number!",
                type: "error",
                })
            );
            return
        }
        if(!equation){
            dispatch(
                setToastMessage({
                message: "Equation is required!",
                type: "error",
                })
            );
            return
        }

        setGameTypeEquation([...gameTypeEquation,{
            "gameTypeId": currentGameType?.gameTypeId,
            "gameType": currentGameType?.gameType,
            "exchangeUnitRate":parseFloat(exchangeUnit),
            "equation":equation,
            "showPositive": positive,
            "active": true
            }
        ]);       
    }

    const removeEquation = (gameTypeId) => {
        setGameTypeEquation(prev => prev.filter(el=> el.gameTypeId !== gameTypeId))
    }
    

            return (
                    <div className='bg-bgColor w-full h-auto px-10 py-4 relative'>
                        <div className='pt-6'>
                            <input 
                                type="number" 
                                placeholder='Exchange Unit Rate' 
                                className='w-[300px] px-2 py-2 font-semibold outline-none' 
                                step="0.1" 
                                min="0" 
                                value={exchangeUnit} 
                                onChange={(e)=>setExchangeUnit(e.target.value)}
                            />
                        </div>
                        <div className='mt-2 relative w-[300px]'>
                            <input 
                                type="text" 
                                placeholder='Equation'
                                value={equation} 
                                className='px-2 py-2 font-semibold outline-none w-full' 
                                onChange={(e)=>setEquation(e.target.value)}
                            />
                            
                            <img src={closeLogo} alt="close"className='absolute top-[8px] right-2 cursor-pointer'
                                onClick={()=>setEquation("")}
                            />
                        </div>
                        <div className='mt-6 px-4 font-semibold text-fgColor'>
                            <div className='flex items-center w-5/12 mt-2 mb-6'>
                                <input 
                                    onClick={(e)=>setPositive(e.target.checked)} 
                                    name='chkPositive' 
                                    type="checkbox" 
                                    className='scale-125 me-2 col-span-2'/>
                                <label htmlFor='chkPositive'>
                                        Show Positive
                                </label>
                            </div>
                            {
                                <button 
                                  className='bg-primary rounded-md text-bgColor my-4 w-[150px] h-[40px]'
                                  onClick={handelAddEquation}>
                                    Add...
                                </button>
                            }

                            <div className='mb-6 w-[80%]'>
                                { gameTypeEquation &&  gameTypeEquation.map((equation, index)=>(
                                    <div key={index} className='flex items-center justify-between w-full bg-borderColor2 rounded-md px-2 py-2 mt-2'>
                                        <div className='w-[30%]'>{equation.gameType}</div>
                                        <div className='flex justify-end w-[10%]'>{equation?.exchangeUnitRate}</div>
                                        <div className='flex justify-end w-[20%]'>{equation?.equation}</div>
                                        <div className='flex justify-end w-[30%]'>{equation?.showPositive ? 'positive' : 'negative'}</div>
                                        <div className='flex justify-end w-[10%]'>
                                            <img src={closeLogo} className='w-6' alt="close logo" onClick={() => removeEquation(equation?.gameTypeId)} />
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
  )
}

export default AddEquation 
